import xLogo from "@/assets/social-media/x-logo.svg";
import tikTokLogo from "@/assets/social-media/tik-tok-logo.svg";
import instagramLogo from "@/assets/social-media/instagram-logo.svg";
import facebookLogo from "@/assets/social-media/facebook-logo.svg";
import linkedInLogo from "@/assets/social-media/linkedin-logo.svg";
import redditLogo from "@/assets/social-media/reddit-logo.svg";
import whatsAppLogo from "@/assets/social-media/whats-app-logo.svg";
import telegramLogo from "@/assets/social-media/telegram-logo.svg";
import twitchLogo from "@/assets/social-media/twitch-logo.svg";
import emailLogo from "@/assets/social-media/email-logo.svg";
import discordLogo from "@/assets/social-media/discord-logo.svg";
import youtubeLogo from "@/assets/social-media/youtube-logo.svg";
import xLogoHover from "@/assets/social-media/x-logo-hover.svg";
import tikTokLogoHover from "@/assets/social-media/tik-tok-logo-hover.svg";
import instagramLogoHover from "@/assets/social-media/instagram-logo-hover.svg";
import facebookLogoHover from "@/assets/social-media/facebook-logo-hover.svg";
import linkedInLogoHover from "@/assets/social-media/linkedin-logo-hover.svg";
import redditLogoHover from "@/assets/social-media/reddit-logo-hover.svg";
import whatsAppLogoHover from "@/assets/social-media/whats-app-logo-hover.svg";
import telegramLogoHover from "@/assets/social-media/telegram-logo-hover.svg";
import twitchLogoHover from "@/assets/social-media/twitch-logo-hover.svg";
import emailLogoHover from "@/assets/social-media/email-logo-hover.svg";
import discordLogoHover from "@/assets/social-media/discord-logo-hover.svg";

export interface SocialMedia {
  title: string;
  icon: string;
  hoverIcon: string;
  urlGenerator: (title: string, url: string) => string;
  servicePageUrl?: string;
}

const xMedia = {
  title: "X",
  icon: xLogo,
  hoverIcon: xLogoHover,
  urlGenerator: (title: string, url: string) =>
    `https://x.com/intent/post?text=${title}&url=${url}`,
  servicePageUrl: "https://x.com/audiomodifyx",
} as SocialMedia;

const instagramMedia = {
  title: "Instagram",
  icon: instagramLogo,
  hoverIcon: instagramLogoHover,
  urlGenerator: () => "https://www.instagram.com/",
  servicePageUrl: "https://www.instagram.com/musconv/",
} as SocialMedia;

const tikTokMedia = {
  title: "TikTok",
  icon: tikTokLogo,
  hoverIcon: tikTokLogoHover,
  urlGenerator: () => "https://www.tiktok.com/",
  servicePageUrl: "https://www.tiktok.com/@musconvapp",
} as SocialMedia;

const discordMedia = {
  title: "Discord",
  icon: discordLogo,
  hoverIcon: discordLogoHover,
  urlGenerator: (title: string, url: string) => `https://musconv.com/discord`,
  servicePageUrl: "https://musconv.com/discord",
} as SocialMedia;

const youtubeMedia = {
  title: "YouTube",
  icon: youtubeLogo,
  hoverIcon: youtubeLogo,
  urlGenerator: (title: string, url: string) => `https://youtube.com`,
  servicePageUrl: "https://www.youtube.com/@musconv",
} as SocialMedia;

export const sideBarSocialMedias: SocialMedia[] = [
  youtubeMedia,
  instagramMedia,
  tikTokMedia,
  discordMedia,
];

export const socialMedias = [
  xMedia,
  tikTokMedia,
  instagramMedia,
  {
    title: "Facebook",
    icon: facebookLogo,
    hoverIcon: facebookLogoHover,
    urlGenerator: (_: string, url: string) =>
      `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  },
  {
    title: "LinkedIn",
    icon: linkedInLogo,
    hoverIcon: linkedInLogoHover,
    urlGenerator: (title: string, url: string) =>
      `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${title}&source=${url}`,
  },
  {
    title: "Reddit",
    icon: redditLogo,
    hoverIcon: redditLogoHover,
    urlGenerator: (title: string, url: string) =>
      `https://reddit.com/submit/?url=${url}&resubmit=true&title=${title} ${url}&type=TEXT`,
  },
  {
    title: "WhatsApp",
    icon: whatsAppLogo,
    hoverIcon: whatsAppLogoHover,
    urlGenerator: (title: string, url: string) =>
      `whatsapp://send?text=${title}%20${url}`,
  },
  {
    title: "Telegram",
    icon: telegramLogo,
    hoverIcon: telegramLogoHover,
    urlGenerator: (title: string, url: string) =>
      `https://telegram.me/share/url?url=${url}&text=${title}`,
  },
  {
    title: "Twitch",
    icon: twitchLogo,
    hoverIcon: twitchLogoHover,
    urlGenerator: (title: string, url: string) => `https://www.twitch.tv/`,
  },
  discordMedia,
  {
    title: "Email",
    icon: emailLogo,
    hoverIcon: emailLogoHover,
    urlGenerator: (title: string, url: string) =>
      `mailto:?subject=${title}&body=${url}`,
  },
] as SocialMedia[];
